import { useCountry } from '../../components/CountrySelector';
import { useSkippableQuery } from '../useSkippableQuery';
import { useUser } from '../useUser';
import { GET_ORDER_QUERY } from './order.rest';

export const useOrder = (orderNumber: string) => {
  const { country } = useCountry();
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error } = useSkippableQuery(GET_ORDER_QUERY, {
    variables: { countryCode: country.alpha2Code, orderNumber },
    skip: !orderNumber || !accessToken
  });

  return { order: data?.getOrder.data[0], orderItems: data?.getOrder.included, loading, error };
};
